<template>

    <section class="news-section list__mod">
      <header-inner/>
      <wrapper :line-borders="false" :line-center="true">
        <menu-news @currentMenu="currentMenu($event)"></menu-news>
        <section  v-if="entitiesLoaded">

          <div class="title-main"><h1 v-html="world.title"></h1></div>

          <news-Big-slide  v-if="entities[0]"
                           :title="entities[0].title"
                           :image="entities[0].image"
                           :link="'/news/world/'+ entities[0].id"
                           :linkRef="entities[0].linkRef"
                           :date="entities[0].date"
                           :more="true"
                           class="big-slide"
          ><span v-html="cut(entities[0].text, 200)"></span>
          </news-Big-slide >

          <card-news-small v-if="entities  && index !== 0" v-for="(item,index) in entities" :key="item.id"
                               :title="item.title"
                               :image="item.image"
                               :date="item.date"
                               :id="item.id"
                               :linkTo="'/news/world/'+ item.id"
                               :link="item.url"
                               :text="item.text"
              ></card-news-small>
        </section>


      </wrapper>
    </section>

</template>

<script>
  import HeaderInner from '../../components/header/HeaderInner'

  import CardNewsBig from '../../components/shared/cards/CardNewsBig'
  import CardNewsSmall from '../../components/shared/cards/CardNewsSmall'
  import DateMixin from '../../components/shared/mixins/DateMixin.js'

  //import Slider from "../../components/shared/sliders/Slider";
  import NewsBigSlide from "../../components/shared/sliders/NewsBigSlide";
  import StringMixin from "../../components/shared/mixins/StringMixin";
  import MenuNews from "../../components/news/MenuNews";
  import ContentText from "../../components/shared/content/ContentText";



  export default {
    async asyncData({ $axios, app, route, redirect, store, query }) {
      await Promise.all([
         store.dispatch('content/loadTitle', 'world'),
         store.dispatch('content/loadEntities', { sID: 'world' })
      ]);
        let seoPage = {}
        try {
            seoPage = await $axios.$get(`${process.env.apiUrl}/methods/site/get_page_info/?link=${route.path}`,
                {
                    timeout: 1000 * 5, // Wait for 5 seconds
                }
            );
            return {seoPage}
        } catch (e) {
            seoPage = {id:  '', title: '', description: '', keywords: ''}
            return {seoPage};
        }
    },
    data() {
      return {
        seoMenu: {
          title: null,
          description: null,
          keywords: null,
        }
      };
    },
    head () {
      if(this.seoPage) {
        return {
          title: this.seoPage.title,
          link: [{rel: 'canonical', href: process.env.base + this.$route.path}],
          meta: [
            {
              hid: `description`,
              name: `description`,
              content: this.seoPage.description
            },
            {
              hid: `keywords`,
              name: 'keywords',
              content: this.seoPage.keywords
            }
          ]
        }
      }
    },
    components: {
      HeaderInner,
      CardNewsBig,
      CardNewsSmall,
    //  Slider,
      NewsBigSlide,
      MenuNews,
      ContentText
    },
    mixins: [DateMixin,StringMixin],

    computed: {
      world() {
        return this.$store.state.content.titles.world;
      },
      entitiesLoaded() {
        return this.$store.state.content.entities.world.loaded;
      },
      entities() {
        return this.$store.state.content.entities.world.items;
      },
    },
    methods: {
      urlSharedLink(){
        return `${process.env.base}${this.$route.fullPath}`
      },
      currentMenu(event) {
        //this.seoMenu.title = event.title
      //  this.seoMenu.description = event.description
        //this.seoMenu.keywords = event.keywords
      }
    },
    mounted() {
      // this.$store.dispatch('content/loadTitle', 'world');
      // this.$store.dispatch('content/loadEntities', { sID: 'world' });
    },
    watch: {
      slides() {
        this.$refs.slider.rebuild();
      },
    },

  };
</script>

<style lang="scss" scoped>
  @import "../../assets/vars", "../../assets/mixins";

</style>



// WEBPACK FOOTER //
// pages/news/world.vue